export default "./dist/stdassets/images/icons/redline.png";